import { useEffect } from 'react';
import useApi from './useApi';
import { useAuthStore } from '../context/AuthContext';
import { Role } from '../types/ViewModel/Role';
import { RoleTypeEnum } from '../enums/roleTypeEnum';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import { useNavigate } from 'react-router-dom';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setRole, setLoggedInRole } = useAuthStore();
    const navigate = useNavigate();

    const getRole = () => {
        getApiData({
            endpoint: apiEndpoints['getRoles'].url,
        });
    };

    const isWriter = (enums: RoleTypeEnum[]) => {
        return enums.some((e) => {
            return e === RoleTypeEnum.Admin || e === RoleTypeEnum.FleetPerformanceAnalyst || e === RoleTypeEnum.ShipUser;
        });
    };

    const canEditGlobally = (enums: RoleTypeEnum[]) => {
        return enums.some((e) => {
            return e === RoleTypeEnum.Admin || e === RoleTypeEnum.FleetPerformanceAnalyst;
        });
    };

    const getBestRole = (enums: RoleTypeEnum[]) => {
        if (enums.some((e) => e === RoleTypeEnum.Admin)) {
            return RoleTypeEnum.Admin;
        }
        if (enums.some((e) => e === RoleTypeEnum.FleetPerformanceAnalyst)) {
            return RoleTypeEnum.FleetPerformanceAnalyst;
        }
        if (enums.some((e) => e === RoleTypeEnum.ShipOperator)) {
            return RoleTypeEnum.ShipOperator;
        }
        if (enums.some((e) => e === RoleTypeEnum.ShipUser)) {
            return RoleTypeEnum.ShipUser;
        }
        if (enums.some((e) => e === RoleTypeEnum.OtherOdfjellUser)) {
            return RoleTypeEnum.OtherOdfjellUser;
        }

        return RoleTypeEnum.Unknown;
    };

    useEffect(() => {
        if (state.status === 'success') {
            const roles = state.result as any as string[];
            if (roles && roles.length > 0 && setRole && setLoggedInRole) {
                const writerRole = isWriter(roles as RoleTypeEnum[]);
                const bestRole = getBestRole(roles as RoleTypeEnum[]);
                const editGloballyRole = canEditGlobally(roles as RoleTypeEnum[]);
                const role = new Role(bestRole, writerRole, editGloballyRole);

                const selectedRole: RoleTypeEnum = RoleTypeEnum[localStorage.getItem('selectedRole')];
                if (selectedRole) {
                    setRole(new Role(selectedRole, isWriter([selectedRole]), canEditGlobally([selectedRole])));
                } else {
                    setRole(role);
                }
                setLoggedInRole(role);
            }
        } else {
            if (state.error?.response?.status === 401) {
                setRole(null);
                setTimeout(() => navigate('/unauthorized'), 0);
            } else {
                processApiEndpointError(state);
            }
        }
    }, [state]);

    return { state, getRole, isWriter, canEditGlobally };
};
